import React from 'react';
import { Sparkles } from 'lucide-react';

const IntakeBanner = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div
      data-testid="intake-banner"
      className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-[#3B4BA0] via-[#3B4BA0] to-teal-600 text-white shadow-md"
    >
      <button
        onClick={scrollToContact}
        className="w-full h-10 flex items-center justify-center gap-2 px-4 hover:brightness-110 transition-all duration-200"
        aria-label="Now accepting students for August 2026 intake — Enquire now"
      >
        <Sparkles className="h-4 w-4 flex-shrink-0 hidden sm:inline-block" />
        <span className="text-xs sm:text-sm font-semibold tracking-wide">
          Now accepting students for August 2026 intake
        </span>
        <span className="hidden sm:inline text-xs sm:text-sm font-medium opacity-90">
          — Enquire today
        </span>
        <span className="sm:hidden text-xs font-medium opacity-90 underline">
          Enquire
        </span>
      </button>
    </div>
  );
};

export default IntakeBanner;
